/**
 * Regras de senha e prazo do link de redefinição.
 *
 * Módulo PURO de propósito: sem `crypto`, sem banco, sem `next/*`. É o que
 * permite que a TELA importe daqui. Sem isso, a exigência mostrada ao usuário
 * ("pelo menos 8 caracteres", "o link vale 30 minutos") seria um número digitado
 * à mão no componente, e o dia em que a regra do servidor mudasse a tela
 * continuaria prometendo a regra antiga — que é a pior forma de erro de
 * validação: a que só aparece depois que a pessoa já digitou.
 *
 * A parte que mexe com token (geração e hash) mora em `password-reset.ts`,
 * porque usa `crypto` e não pode ir para o navegador.
 */

/** Mesma exigência do restante do sistema (ver scripts/create-admin.ts). */
export const SENHA_MINIMA = 8

/**
 * Teto de 72 BYTES: o bcrypt ignora silenciosamente tudo depois do 72º byte.
 * Sem este limite, o usuário digitaria uma frase longa acreditando que ela toda
 * protege a conta, quando só o começo dela conta. Melhor recusar e explicar.
 */
export const SENHA_MAXIMA_BYTES = 72

/**
 * 30 minutos.
 *
 * A faixa defensável é 30–60; escolhemos o piso dela. O link chega em segundos e
 * o usuário está com a tela aberta esperando — o tempo que ele realmente usa é
 * de um a dois minutos. Todo o resto é só janela de exposição de uma credencial
 * que troca a senha sozinha: o e-mail fica na caixa de entrada (que pode ser
 * lida por quem senta na máquina depois), pode ser encaminhado sem pensar, e
 * passa por filtros e arquivos corporativos no caminho. Dobrar para 60 minutos
 * não atenderia nenhum caso real de uso e dobraria essa janela.
 */
export const EXPIRACAO_MINUTOS = 30

/** `null` quando a senha serve; senão, a frase que a tela mostra. */
export function motivoSenhaInvalida(senha: string): string | null {
  if (senha.length < SENHA_MINIMA) {
    return `A senha precisa ter pelo menos ${SENHA_MINIMA} caracteres.`
  }
  // `Buffer` não existe no navegador; a contagem de bytes UTF-8 aqui é feita
  // pelo TextEncoder, que existe nos dois lados.
  if (new TextEncoder().encode(senha).length > SENHA_MAXIMA_BYTES) {
    return `A senha é longa demais. Use no máximo ${SENHA_MAXIMA_BYTES} caracteres.`
  }
  return null
}
